export default __webpack_public_path__ + "static/media/delivery.inline.543f70fc.svg";